<template>
    <van-nav-bar
      title="活动详情"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
  <div class="mx-0 w-full h-18 filter drop-shadow-lg">
    <img-swiper :list="swiperList"></img-swiper>
  </div>

  <div
    class="
      mx-2
      mt-1
      p-1
      filter
      drop-shadow-md
      rounded-sm
      bg-white
      grid grid-cols-3
      items-center
      gap-0.5
    "
  >
    <div class="col-span-2 small-text text-bold">{{event.title}}</div>
    <div class="text-gray-500">剩余报名人数：{{event.maxPerson - event.usernumber}}</div>
    <div class="col-span-3 text-gray-500">{{event.abstract}}</div>
    <div class="col-span-3 text-gray-500">
      <van-icon name="location" />{{event.place}}
    </div>
    <div class="place-self-center small-text text-bold">{{event.organizer}}</div>
    <div class="place-self-center small-text text-bold">{{event.contact}}</div>
    <div class="place-self-center small-text text-bold">{{event.tel}}</div>
    <div class="place-self-center text-gray-500">主办方</div>
    <div class="place-self-center text-gray-500">联系人</div>
    <div class="place-self-center text-gray-500">联系方式</div>
  </div>
  <div class="mx-2 mt-1 p-1 rounded-sm bg-white">
    <div class="middle-text text-bold">活动详情</div>
    <div class=" text-gray-500 small-text desc">
      {{event.content}}
    </div>
  </div>
  <div class="mx-2 mt-1 p-1 rounded-sm bg-white"><van-field type="tel" placeholder="请输入手机号码" v-model="mobile" label="联系方式：" /></div>
  <div class="mx-2 mt-1 p-1 text-gray-400">报名截止时间：{{event.deadline}}</div>
  <div class="mx-2 w-36 bottom-1">
    <van-button block color="#49cfd4" @click="applyNow(event)">立即报名</van-button>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import ImgSwiper from "@/components/ImgSwiper";
import { useRouter , useRoute} from 'vue-router';
import { getEventDetail,applyEvent } from '@/service/home';
import {Toast} from 'vant';
import Cookies from 'js-cookie';
import qs from 'qs';
export default {
  name: "eventDetail",
  components: {
    ImgSwiper,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const user = JSON.parse(Cookies.get("user"));
    const state = reactive({
      swiperList: [], // 轮播图列表
      event:{},
      mobile:""
    });
    const goBack = ()=> router.go(-1);
    onMounted(async () => {
      state.swiperList = [];
      const {data:eventData} = await getEventDetail(route.params.id);
      state.event = eventData[0];
    });
    const applyNow = async(event) => {
      const mobilePattern =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
      if (!mobilePattern.test(state.mobile)) {
        Toast.fail("手机号码不正确");
        return;
      }
      const result = await applyEvent(event.id, qs.stringify({userid:user.userid, id:event.id, mobile:state.mobile}));
      console.log(result)
    }
    return {
      applyNow,
      ...toRefs(state),
      goBack
    };
  },
};
</script>

<style lang="less" scoped>
.desc{
    width:100%;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

</style>
